import { Action, ResetExpiredPasswordError, ThunkAction, ThunkDispatch } from '../types';
import { captureException } from '../utilities/analytics/error-reporting';

export const init = (): Action => ({
  type: 'EXPIRED_PASSWORD_RESET_REQUEST_INITIATE',
});

export const requestResetSuccess = (): Action => ({
  type: 'EXPIRED_PASSWORD_RESET_REQUEST_SUCCESS',
});

export const requestResetFailed = (error: ResetExpiredPasswordError): Action => ({
  type: 'EXPIRED_PASSWORD_RESET_REQUEST_FAILED',
  error: error,
});

export const requestResetExpiredPassword =
  (token: string): ThunkAction =>
  (dispatch: ThunkDispatch) => {
    dispatch(init());
    return fetch('/rest/resetexpiredpassword', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: token,
      }),
    })
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return Promise.reject(new Error(response.status.toString()));
      })
      .then(({ isSuccessful }) => {
        if (isSuccessful === true) {
          dispatch(requestResetSuccess());
        } else {
          dispatch(requestResetFailed('invalid_token'));
        }
      })
      .catch(error => {
        switch (error.message) {
          case '401':
            dispatch(requestResetFailed('invalid_token'));
            break;

          case '429':
            dispatch(requestResetFailed('too_many_requests'));
            break;

          default:
            dispatch(requestResetFailed('generic_error'));
            captureException(error);
            break;
        }
      });
  };
